export default __webpack_public_path__ + "static/media/claro.mtex.app.05484ce3.png";